import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import router from './router'

import AppLayout from '@/layouts/App'
import AppSimpleLayout from '@/layouts/AppSimple'

Vue.component('app-layout', AppLayout)
Vue.component('app-simple-layout', AppSimpleLayout)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
